export const API_ENDPOINT_CREDENTIAL_ADD_NEW = `${process.env.REACT_APP_API_URL}/creds/airline/add`;
export const API_ENDPOINT_CREDENTIAL_ADD_BULK = `${process.env.REACT_APP_API_URL}/creds/airline/addBulk`;
export const API_ENDPOINT_CREDENTIAL_COUNT_GST = `${process.env.REACT_APP_API_URL}/creds/gstportal/credsCountGST`;
export const API_ENDPOINT_CREDENTIAL_COUNT_EMAIL = `${process.env.REACT_APP_API_URL}/creds/email/credsCountEmail`;
export const API_ENDPOINT_CREDENTIAL_COUNT_AIRLINE = `${process.env.REACT_APP_API_URL}/creds/airline/credsCountAirline`;
